export default __webpack_public_path__ + "static/media/Flag_of_Colombia.49a1e31d.svg";